import { VODState } from '../useVODStore'

export const selectActualPagePosition = (state: VODState) =>
    state.actualPagePosition

export const selectProductId = (state: VODState) => state.productId

export const selectItemDetails = (state: VODState) => state.itemDetails

export const selectSetItemDetails = (state: VODState) => state.setItemDetails
export const selectRemoveItemDetails = (state: VODState) =>
    state.removeItemDetail

export const selectSearchItemDetails = (state: VODState) =>
    state.searchItemDetails

export const selectVodRows = (state: VODState) => state.vodRows

export const selectSetVodRows = (state: VODState) => state.setVodRows

export const selectVodRowsCategories = (state: VODState) =>
    state.vodRowsCategories

export const selectVodRowItems = (state: VODState) => state.vodRowItems

export const selectSetIsLinkedFromHome = (state: VODState) =>
    state.setIsLinkedFromHome

export const selectVodPages = (state: VODState) => state.vodPages
export const selectIsVodDetailsPageRendered = (state: VODState) =>
    state.isVodDetailsPageRendered
export const selectSetVodPages = (state: VODState) => state.setVodPages

export const selectVodCachedDetails = (state: VODState) =>
    state.vodCachedDetails

export const selectVodRowItemType = (state: VODState) => state.vodRowItemType

export const selectIsVodContentVisible = (state: VODState) =>
    state.isVodContentVisible

export const selectSelectedVOD = (state: VODState) => state.selectedVOD

export const selectSetSearchItemDetails = (state: VODState) =>
    state.setSearchItemDetails

export const selectResetItemDetails = (state: VODState) => state.resetItemDetail

export const selectSetSelectedVOD = (state: VODState) => state.setSelectedVOD
export const selectSetActualEpisode = (state: VODState) =>
    state.setActualEpisode

export const selectSetActualSeason = (state: VODState) => state.setActualEpisode
export const selectSetLastFocusedItem = (state: VODState) =>
    state.setLastFocusedItem

export const selectSetVodRowItems = (state: VODState) => state.setVodRowItems

export const selectSetVodRowItemType = (state: VODState) =>
    state.setVodRowItemType

export const selectSetVodCachedDetails = (state: VODState) =>
    state.setVodCachedDetails

export const selectSetVodRowsCategories = (state: VODState) =>
    state.setVodRowsCategories

export const selectSetActualPagePosition = (state: VODState) =>
    state.setActualPagePosition

export const selectResetVodPages = (state: VODState) => state.resetVodPages
export const selectSetIsVodContentPlaying = (state: VODState) =>
    state.setIsVodContentPlaying
